import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import "../doorstepServices/DoorstepServices.css"
import { IWithdrawReq } from "src/helper/interfaces";
import FilterButton from "src/components/layout/FilterButton";
import Cookies from "js-cookie";
import moment from "moment";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import LoadingGif from "src/components/layout/Loader";
import Paginator from "src/components/layout/Paginator";
import { formatCategory, formatDiffrentDate } from "src/utils/normalFuntions";
import { Modal } from "react-bootstrap";
import { Button, Col, Row, Form } from "react-bootstrap";
import { Formik } from 'formik';
import * as yup from 'yup';

interface ModalValues {
   wallet_amount: string;
   requested_amount: string;
   bank_name: string;
   ifsc_code: string;
   acc_number: string;
   acc_name: string;
   payment_id: string;
   amount: string;
   approve_type: string;

}
const getAllWithdrwalReqs = async (token: string, pageNumber: number, pageSize: number, searchValue: string, selectedOption: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/withdraw-requests`, {
      headers: {
         "x-access-token": token
      },
      params: {
         type: selectedOption.toLocaleLowerCase(),
         page: pageNumber,
         search_value: searchValue,
         pageSize
      }

   })
};


const WithdrawalRequests = () => {
   const selectedOption = useAppSelector((state) => state.requirementAnsSupport.withdrawOption.option);
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const [show, setShow] = useState({
      edit: false,
      create: false,
      view: false,
      paid: false
   });
   const [paymentId, setPaymentId] = useState("");
   const Token = Cookies.get('token');
   const [selectedRequest, setSelectedRequest] = useState<IWithdrawReq>();
   const [searchVal, setSearchVal] = useState('');
   const [withdrawReqs, setWithdrawReqs] = useState<any[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const [showModal, setShowModal] = useState(false);

   const handleClose = () => setShowModal(false);
   useEffect(() => {
      setPageNo(1)
   }, [selectedOption])
   useEffect(() => {
      if (!Token) return;
      dispatch(startLoading());
      getAllWithdrwalReqs(Token as string, pageNo, pageSize, searchVal, selectedOption).then((res) => {
   // console.log(res)
         if (res?.data?.status_code === 200) {
            setWithdrawReqs(res?.data?.data?.data);
            setTotalPages(res?.data?.data?.totalPages)
         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${res?.data?.data?.msg}`,
               // footer: '<a href="#">Why do I have this issue?</a>'
            });
         }
      }).catch((err) => {
         throw err;
      }).finally(() => {
         dispatch(stopLoading());
      })
   }, [Token, show?.edit, pageNo, pageSize, searchVal, selectedOption])

   const initialValues: ModalValues = {
      wallet_amount: "",
      requested_amount: "",
      bank_name: "",
      ifsc_code: "",
      acc_number: "",
      acc_name: "",
      payment_id: "",
      amount: "",
      approve_type: ""

   };

   const [inputs, setInputs] = useState(initialValues);

   const handleFormSubmit = async (formInput: ModalValues, resetForm: () => void) => {
      if (!Token) return;
      dispatch(startLoading());
      try {
         await axios.post(`${AppConfig.DEV_SERVER}/withdrawal-transaction`, {
            payment_id: formInput?.payment_id,
            requested_amount: formInput?.amount,
            request_id: selectedRequest?._id,
            type: "accept"
         }, {
            headers: {
               'content-type': 'application/json',
               "X-Access-Token": Token
            }
         }).then((res) => {
            // console.log("res: ", res?.data)
            if (res?.data?.status_code !== 200) {
               setTimeout(() => {
                  Swal.fire({
                     position: "center",
                     icon: "error",
                     title: "Error..!",
                     text: `${res?.data?.msg}`,
                     showConfirmButton: false,
                     timer: 3000
                  }).then(() => resetForm())
                  dispatch(stopLoading());
               }, 1000);
            }
            else if (res?.data?.status_code === 200) {
               setTimeout(() => {

                  setShowModal(false);
                  Swal.fire({
                     position: "center",
                     icon: "success",
                     title: "Successfull !!",
                     text: res?.data?.msg,
                     showConfirmButton: false,
                     timer: 2000
                  }).then(() => {
                     resetForm();
                     getAllWithdrwalReqs(Token as string, pageNo, pageSize, searchVal, selectedOption).then((res) => {
                     // console.log(res)
                        if (res?.data?.status_code === 200) {
                           setWithdrawReqs(res?.data?.data?.data);
                           setTotalPages(res?.data?.data?.totalPages)
                        } else {
                           Swal.fire({
                              icon: "error",
                              title: "Oops...",
                              text: `${res?.data?.data?.msg}`,

                           });
                        }
                     })
                  })
                  setShow({
                     ...show,
                     view: false,
                     paid: false
                  })
                  dispatch(stopLoading());
               }, 600 * 2);
            }
         })

         // console.log('Response data:', response.data);
      } catch (error: any) {
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   }

   const handleReject = async (id: string) => {
      if (!Token) return;
      // console.log(id)
      dispatch(startLoading());
      try {
         Swal.fire({
            title: 'Are you sure?',
            text: "You cant't revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, reject the request!'
         }).then(async (response) => {
            if (response.isConfirmed) {
               // console.log("lamao")
               await axios.post(`${AppConfig.DEV_SERVER}/withdrawal-transaction`, {
                  request_id: id,
                  type: "reject"
               }, {
                  headers: {
                     'content-type': 'application/json',
                     "X-Access-Token": Token
                  }
               }).then((res) => {
                  // console.log("res: ", res?.data)
                  if (res?.data?.status_code !== 200) {
                     setTimeout(() => {
                        Swal.fire({
                           position: "center",
                           icon: "error",
                           title: "Error..!",
                           text: `${res?.data?.msg}`,
                           showConfirmButton: false,
                           timer: 3000
                        })
                        dispatch(stopLoading());
                     }, 1000);
                  }
                  else if (res?.data?.status_code === 200) {
                     setTimeout(() => {

                        setShowModal(false);
                        Swal.fire({
                           position: "center",
                           icon: "success",
                           title: "Successfull !!",
                           text: res?.data?.msg,
                           showConfirmButton: false,
                           timer: 2000
                        }).then(() => {

                           getAllWithdrwalReqs(Token as string, pageNo, pageSize, searchVal, selectedOption).then((res) => {
                           // console.log(res)
                              if (res?.data?.status_code === 200) {
                                 setWithdrawReqs(res?.data?.data?.data);
                                 setTotalPages(res?.data?.data?.totalPages)
                              } else {
                                 Swal.fire({
                                    icon: "error",
                                    title: "Oops...",
                                    text: `${res?.data?.data?.msg}`,

                                 });
                              }
                           })
                        })

                        dispatch(stopLoading());
                     }, 600 * 2);
                  }
               })
            }
         });


         // console.log('Response data:', response.data);
      } catch (error: any) {
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   }


   const handleApprove = (id: string) => {
      const requirementToEdit: IWithdrawReq = withdrawReqs.find((service) => service._id === id);
      // console.log(requirementToEdit)
      setSelectedRequest(requirementToEdit);
      setInputs({
         ...inputs,
         wallet_amount: requirementToEdit?.wallet_amount?.toFixed(2),
         requested_amount: requirementToEdit?.amount?.toFixed(2),
         bank_name: requirementToEdit?.bank_details?.bank_name,
         ifsc_code: requirementToEdit?.bank_details?.IFSC_code,
         acc_name: requirementToEdit?.bank_details?.account_holder_name,
         acc_number: requirementToEdit?.bank_details?.account_number,
         amount: requirementToEdit?.amount?.toFixed(2)
      })

      setShowModal(true)
   }

   const validationSchema = yup.object().shape({
      amount: yup.number()
         .required("Amount is required")
         .test("max-amount", "Amount should be less than wallet amount", function (value) {
            if (selectedRequest?.wallet_amount) {
               return value < selectedRequest?.wallet_amount
            }
         }),
      payment_id: yup.string()
         .required('Please Fill this field (Payment Id).'),
   });

   const handlePageSizeChange = (e: any) => {
      setPageSize(e?.target?.value)
   }

   return (
      <MainLayout
         showAllFilters={false}
         searchValue={searchVal}
         onChange={(e) => setSearchVal(e.target?.value)}
      >

         <div className="mt-3 mb-3">
            {
               loading ?
                  <div>
                     <LoadingGif />
                  </div>
                  : ""
            }
            <Formik
               validationSchema={validationSchema}
               onSubmit={(values, { resetForm }) => {
                  handleFormSubmit(values, resetForm)
               }}
               enableReinitialize={true}
               validateOnChange={false}
               validateOnBlur={false}
               initialValues={inputs}
            >
               {({ handleSubmit, handleChange, setFieldValue, values, touched, errors }) => (
                  <Modal show={showModal} onHide={handleClose} size="lg" className="rounded-9 category-modal">
                     <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                           <Modal.Title as="h5">Approve Request</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                           <Row className="fieldset-row" >
                              {
                                 loading ?
                                    <div className="d-flex align-items-center withdraw-loading">
                                       <LoadingGif />
                                    </div>
                                    :
                                    ""
                              }
                              <Col md={6} className="mb-2">
                                 <Form.Label htmlFor="wallet_amount">Wallet Amount</Form.Label>
                                 <Form.Control id="wallet_amount" type='text' onChange={handleChange} name="wallet_amount" isValid={touched.wallet_amount && !errors.wallet_amount} value={values.wallet_amount} isInvalid={!!errors.wallet_amount} readOnly />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.wallet_amount}
                                 </Form.Control.Feedback>
                              </Col>
                              <Col md={6} className="mb-2">
                                 <Form.Label htmlFor="requested_amount">Requested Amount</Form.Label>
                                 <Form.Control id="requested_amount" type='text' onChange={handleChange} name="requested_amount" isValid={touched.requested_amount && !errors.requested_amount} value={values.requested_amount} isInvalid={!!errors.requested_amount} readOnly />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.requested_amount}
                                 </Form.Control.Feedback>
                              </Col>
                              <Col md={6} className="mb-2">
                                 <Form.Label htmlFor="bank_name">Bank Name</Form.Label>
                                 <Form.Control id="bank_name" type='text' onChange={handleChange} isValid={touched.bank_name && !errors.bank_name} value={values.bank_name} isInvalid={!!errors.bank_name} readOnly />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.bank_name}
                                 </Form.Control.Feedback>
                              </Col>

                              <Col md={6} className="mb-2">
                                 <Form.Label htmlFor="ifsc_code">IFSC Code</Form.Label>
                                 <Form.Control id="ifsc_code" type='text' onChange={handleChange} name="ifsc_code" isValid={touched.ifsc_code && !errors.ifsc_code} value={values.ifsc_code} isInvalid={!!errors.ifsc_code} readOnly />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.ifsc_code}
                                 </Form.Control.Feedback>
                              </Col>
                              <Col md={6} className="mb-2">
                                 <Form.Label htmlFor="acc_number">Account Number</Form.Label>
                                 <Form.Control id="acc_number" type='text' onChange={handleChange} name="acc_number" isValid={touched.acc_number && !errors.acc_number} value={values.acc_number} isInvalid={!!errors.acc_number} readOnly />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.acc_number}
                                 </Form.Control.Feedback>
                              </Col>
                              <Col md={6} className="mb-2">
                                 <Form.Label htmlFor="acc_name">Account Name</Form.Label>
                                 <Form.Control id="acc_name" type='text' onChange={handleChange} name="acc_name" isValid={touched.acc_name && !errors.acc_name} value={values.acc_name} isInvalid={!!errors.acc_name} readOnly />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.acc_name}
                                 </Form.Control.Feedback>
                              </Col>
                              <Col md={6} className="mb-2">
                                 <Form.Label htmlFor="amount">Amount</Form.Label>
                                 <Form.Control id="amount" type='text' onChange={handleChange} name="amount" isValid={touched.amount && !errors.amount} value={values.amount} isInvalid={!!errors.amount} />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.amount}
                                 </Form.Control.Feedback>
                              </Col>
                              <Col md={6} className="mb-2">
                                 <Form.Label htmlFor="payment_id">Payment Id</Form.Label>
                                 <Form.Control id="payment_id" type='text' onChange={handleChange} name="payment_id" isValid={touched.payment_id && !errors.payment_id} value={values.payment_id} isInvalid={!!errors.payment_id} />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.payment_id}
                                 </Form.Control.Feedback>
                              </Col>

                           </Row>
                        </Modal.Body>

                        <Modal.Footer >
                           {/* <Button variant="app-warning" type="button" className="ps-4 pe-4 btn-primary">
                              Reject
                           </Button> */}

                           <Button variant="app-warning" type="submit" className="ps-4 pe-4 btn-success">
                              Approve
                           </Button>
                        </Modal.Footer>
                     </Form>
                  </Modal>
               )
               }
            </Formik >

            <div className="card category-main me-2 p-md-4">


                     <div>
                        <div className="d-flex justify-content-end mb-3 gap-3">
                           <div className="d-flex gap-2">
                              <span className="d-flex align-items-center pagesize-text">
                                 PageSize
                              </span>

                              <select
                                 className="form-select"
                                 style={{ backgroundPosition: "right 5px center", width: "60px" }}
                                 aria-label="Default select example"
                                 value={pageSize} // Bind the value to the state
                                 onChange={handlePageSizeChange} // Handle the change
                              >
                                 <option value={20}>20</option>
                                 <option value={50}>50</option>
                                 <option value={100}>100</option>
                                 <option value={200}>200</option>
                              </select>
                           </div>
                           {/* <div>
                              <ExportDocs headers={headers} formattedData={formattedData} clickHandler={exportPDF} />
                           </div> */}

                           <div className="d-flex justify-content-end gap-4 ">
                              <FilterButton
                                 name={selectedOption}
                                 type="withdraw"
                                 options={["Pending", "Rejected", "Completed"]}

                              />

                           </div>

                        </div>
                        <div className="table-extra-responsive">
                           <table className="table table-striped card-body">
                              <thead>
                                 <tr className="category-tr">
                                    {/* <th scope="col" className="text-start ps-4">name</th> */}
                                    <th scope="col" className="text-start ps-4">Sr.No.</th>
                                    <th scope="col" className="text-start ps-4">Request Id</th>
                                    <th scope="col" className="text-start ps-4">Worker Name </th>
                                    <th scope="col" className="text-start ps-4"> Worker Type </th>
                                    <th scope="col" className="text-start ps-4"> Wallet Amount </th>
                                    <th scope="col" className="text-start ps-4">Requested Amount </th>
                                    <th scope="col" className="text-start ps-4">Bank name </th>
                                    <th scope="col" className="text-start ps-4">Phone</th>
                                    <th scope="col" className="text-start ps-4">Status </th>
                                    <th scope="col" className="text-start ps-4">Requested Date </th>
                                    <th scope="col" className="text-start ps-4">last Pay Day </th>
                                    {
                                       selectedOption === "Pending" && <th scope="col" className="cat_btns">Action</th>
                                    }

                                 </tr>
                              </thead>
                              <tbody>
                                 {
                                    withdrawReqs && withdrawReqs?.map((data: IWithdrawReq, i) => {

                                       const requestedDate = formatDiffrentDate(data?.createdAt);
                                       const lastPayDate = formatDiffrentDate(data?.lastPayDate);
                                       const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                                       return (

                                          <tr key={data?._id}>

                                             <td className="text-start ps-4 pt-3">{rowNumber}</td>
                                             <td className="text-start ps-4 pt-3">{data?.unique_code}</td>
                                             <td className="text-start ps-4 pt-3">{data?.name}</td>
                                             <td className="text-start ps-4 pt-3">{formatCategory(data?.worker_type)}</td>

                                             <td className="text-start ps-4 pt-3">&#8377; {data?.wallet_amount.toFixed(2)}</td>
                                             <td className="text-start ps-4 pt-3">&#8377; {data?.amount.toFixed(2)}</td>
                                             {/* <td className="text-start ps-4 pt-3">{data?._id}</td> */}
                                             <td className="text-start ps-4 pt-3">{data?.bank_details.bank_name}</td>
                                             <td className="text-start ps-4 pt-3">{data?.phone}</td>

                                             <td className="text-start ps-4 pt-3">{data?.status}</td>
                                             <td className="text-start ps-4 pt-3">   {requestedDate?.formattedDate} <br />{requestedDate?.formattedHours}</td>
                                             <td className="text-start ps-4 pt-3">   {lastPayDate?.formattedDate} <br />{lastPayDate?.formattedHours}</td>

                                             {selectedOption === "Pending" &&
                                                <td className="align-content-center ">
                                                   <div className="d-flex justify-content-evenly gap-3">
                                                      {/* <PaymentComponent
                                                         amount={data?.amount}
                                                         name={data?.name}
                                                         phone={data?.phone}
                                                         request_id={data?._id}
                                                         token={Token as string}
                                                      /> */}
                                                      <button className="btn btn-sm btn-success" onClick={() => handleApprove(data?._id)}>
                                                         Approve
                                                      </button>
                                                      <button className="btn btn-sm btn-primary" onClick={() => handleReject(data?._id)}>
                                                         Reject
                                                      </button>
                                                   </div>

                                                </td>
                                             }

                                          </tr>
                                       )
                                    }
                                    )
                                 }


                              </tbody>

                           </table>

                        </div>

                        <Paginator
                           totalPages={totalPages}
                           pageNo={pageNo}
                           onPageChange={(e, no) => setPageNo(no)}
                           alignment="right"
                        />
               </div>
            </div>

         </div>

      </MainLayout>
   )

};


export default WithdrawalRequests;